// extracted by mini-css-extract-plugin
export default {"container":"ReplaceProduct_container__ArbiD"};